import { useCallback, useState } from "react";
import ProjectTeamCastResponseResource from "common/resources/Project/Config/Team/Cast/ProjectTeamCastResponseResource";

export enum ECastingCardModal {
	createCast = "createCast",
	editCast = "editCast",
	deleteCast = "deleteCast",
}

export const useCastingCardModal = () => {
	const [openedModal, setOpenedModal] = useState<ECastingCardModal | null>(null);
	const [selectedCast, setSelectedCast] = useState<ProjectTeamCastResponseResource | null>(null);

	const isModalOpen = useCallback((modal: ECastingCardModal) => openedModal === modal, [openedModal]);

	const onCloseModal = useCallback(() => {
		setOpenedModal(null);
		setSelectedCast(null);
	}, []);

	const onOpenCreateModal = useCallback(() => {
		setOpenedModal(ECastingCardModal.createCast);
	}, [setOpenedModal]);

	const onOpenEditModal = useCallback(
		(cast: ProjectTeamCastResponseResource) => {
			setOpenedModal(ECastingCardModal.editCast);
			setSelectedCast(cast);
		},
		[setOpenedModal],
	);

	const onOpenDeleteModal = useCallback(
		(cast: ProjectTeamCastResponseResource) => {
			setOpenedModal(ECastingCardModal.deleteCast);
			setSelectedCast(cast);
		},
		[setOpenedModal],
	);

	return { selectedCast, isModalOpen, onCloseModal, onOpenCreateModal, onOpenEditModal, onOpenDeleteModal };
};
